import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Settings } from '../settings';

@Injectable()

export class GeneralService {

  private contentHeadersJsonWithAuth: HttpHeaders;
  private contentHeadersJson: HttpHeaders;
  private baseUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.baseUrl = Settings.baseUrlBackend;
    this.ini();
  }

  // Métodos generales
  public ini(): void {
    this.contentHeadersJson = new HttpHeaders({'Content-Type': 'application/json'});
    const authorization = 'OAuth ' + localStorage.getItem('APPTenfieldPlayerAccessToken');
    this.contentHeadersJsonWithAuth = new HttpHeaders({'Content-Type':  'application/json', Authorization: authorization});
  }

  getFingerprintData(): Observable<any> {
    this.ini();
    const url = this.baseUrl + '/rest/core/servicios/obtenerDatosFingerprint';
    const body = {};
    const options = { headers: this.contentHeadersJsonWithAuth };

    const request: Observable<any> = this.http.post(url, body, options);
    return request;
  }
}
